export default (function () {
  return {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-button/es/ButtonGroupTheme.js
// module id = 1083
// module chunks = 1